import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RouterState, push } from 'connected-react-router';

import {
  InitializeState,
  InitializeStatus
} from 'common/modules/app/initialize';
import { Principal } from 'common/modules/app/principal';
import { GlossaryState } from 'common/modules/app/glossaries';
import { setHomeButtonClicked } from 'common/modules/app/pageTransition';
import { Glossary } from 'common/utils/glossary';
import { SasPagePath, getPlanListUrl } from 'common/utils/urls';
import { getLogin } from 'common/modules/domain/user';

import { Header } from 'common/components';

import { AppState } from 'pages';

// StoreのStateからComponentに渡すPropsへ
const useStateProps = () => {
  const initState = useSelector<AppState, InitializeState>(
    (state) => state.app.initialize
  );
  const routeState = useSelector<AppState, RouterState>(
    (state) => state.app.router
  );
  const glState = useSelector<AppState, GlossaryState>(
    (state) => state.app.glossaries
  );
  const principalState = useSelector<AppState, Principal>(
    (state) => state.app.principal
  );

  const isDisplayHome =
    routeState.location.pathname !== SasPagePath.PlanList &&
    routeState.location.pathname !== SasPagePath.Error &&
    routeState.location.pathname !== SasPagePath.Completion &&
    routeState.location.pathname !== SasPagePath.DeleteCompletion;

  const isCompleteInit = initState.status === InitializeStatus.FINISH;

  return {
    glossary: Glossary.instance(glState),
    isLoggedIn: principalState.isLoggedIn,
    isDisplayHome: isDisplayHome,
    isCompleteInit: isCompleteInit
  };
};

// Actionをdispatchする関数からComponentに渡すPropsへ
const useDispatchProps = () => {
  const dispatch = useDispatch();

  const onClickLogin = () => {
    dispatch(getLogin());
  };

  const onClickHome = () => {
    dispatch(setHomeButtonClicked(true));
    dispatch(push(getPlanListUrl()));
  };

  return { onClickLogin: onClickLogin, onClickHome: onClickHome };
};

export default function ContainerComponent() {
  const _props = { ...useStateProps(), ...useDispatchProps() };
  return <Header {...{ ..._props }} />;
}
